// Login-method catalogue + effective-enablement helpers, shared by the login
// page, profile (self MFA setup) and the IAM admin (per-user / bulk toggles).
// A method is effectively available to a user when it is BOTH globally enabled
// (branding flag `sec_login_<key>_enabled` !== 'false') AND not in the user's
// `metodi_accesso_disabilitati` list. Mirrors the server gate in
// services/auth-service/src/lib/authMethods.js.

export const AUTH_METHODS = [
  { key: 'passkey', flag: 'sec_login_passkey_enabled', label: 'Passkey', hint: 'Login biometrico (FIDO2/WebAuthn)' },
  { key: 'magic_link', flag: 'sec_login_magic_link_enabled', label: 'Magic Link', hint: 'Link di accesso via email' },
  { key: 'otp', flag: 'sec_login_otp_enabled', label: 'Codice OTP', hint: 'Codice a 6 cifre via email' },
  { key: 'totp', flag: 'sec_login_totp_enabled', label: 'Autenticatore (TOTP)', hint: 'Google Authenticator / Authy' },
  { key: 'temp_password', flag: 'sec_login_temp_password_enabled', label: 'Credenziali', hint: 'Email e password' },
  { key: 'oidc', flag: 'sec_login_oidc_enabled', label: 'SSO', hint: 'Accesso tramite provider OIDC esterno' },
];

const flagFor = (key) => (AUTH_METHODS.find((m) => m.key === key) || {}).flag;

// Globally enabled unless the branding flag is explicitly the string 'false'
// (matches LoginPage's existing `!== 'false'` convention → fail-open).
export function isGloballyEnabled(branding, key) {
  const flag = flagFor(key);
  return !flag || (branding && branding[flag]) !== 'false';
}

export function isMethodEnabledForUser(branding, disabledList, key) {
  if (!isGloballyEnabled(branding, key)) return false;
  return !(Array.isArray(disabledList) && disabledList.includes(key));
}

// The methods an admin can toggle for a user = those globally enabled.
export function globallyEnabledMethods(branding) {
  return AUTH_METHODS.filter((m) => isGloballyEnabled(branding, m.key));
}
